module.exports = __webpack_public_path__ + "b4fb952ae2792112e9cb0b8404712ec0.svg";